import { __rest } from "tslib";
import { BaseStorage } from '../base-storage';
import { getComponentSettings, getGlobalSettings, setComponentSettings, setGlobalSettings, } from '@wix/ambassador-app-settings-v1-settings/http';
import { Host as HostEnum, } from '@wix/ambassador-app-settings-v1-settings/types';
const hostMap = {
    businessManager: HostEnum.BUSINESS_MANAGER,
    viewer: HostEnum.VIEWER,
    oneApp: HostEnum.ONE_APP,
    other: HostEnum.NA,
};
export class AppSettingsStorageStrategy extends BaseStorage {
    constructor(params) {
        super();
        this.httpClient = params.httpClient;
        this.host = params.host;
    }
    get forceGlobalSettings() {
        // ComponentSettings requires componentId in UUID format, so we must use GlobalSettings
        return this.host === 'businessManager';
    }
    _setComponentSettingsCompat(payload) {
        const { forceGlobalSettings } = this;
        if (forceGlobalSettings && payload.componentId) {
            const { componentId: _componentId } = payload, rest = __rest(payload, ["componentId"]);
            return setGlobalSettings(Object.assign(Object.assign({}, rest), { settings: {
                    [payload.componentId]: payload.settings,
                } }));
        }
        return setComponentSettings(payload);
    }
    async _getSettingsCompat(payload) {
        var _a;
        const { httpClient, forceGlobalSettings } = this;
        if (!payload.componentId) {
            const { data } = await httpClient.request(getGlobalSettings(payload));
            return data.settings;
        }
        if (forceGlobalSettings) {
            const { componentId: _componentId } = payload, rest = __rest(payload, ["componentId"]);
            const { data } = await httpClient.request(getGlobalSettings(rest));
            return (_a = data.settings) === null || _a === void 0 ? void 0 : _a[_componentId];
        }
        const { data } = await httpClient.request(getComponentSettings(payload));
        return data.settings;
    }
    _buildAppSettingsPayload(payload, options) {
        const { scope: componentId } = options;
        return Object.assign(Object.assign({}, payload), (componentId && { componentId }));
    }
    async setItem(key, value, options) {
        const { httpClient, host } = this;
        const { namespace } = options;
        const payload = this._buildAppSettingsPayload({
            settings: {
                [namespace]: {
                    [key]: value,
                },
            },
            host: hostMap[host],
        }, options);
        const req = payload.componentId
            ? this._setComponentSettingsCompat(payload)
            : setGlobalSettings(payload);
        await httpClient.request(req);
    }
    async removeItem(key, options) {
        const { httpClient, host } = this;
        const { namespace } = options;
        const payload = this._buildAppSettingsPayload({
            settings: {
                [namespace]: {
                    [key]: null,
                },
            },
            host: hostMap[host],
        }, options);
        const req = payload.componentId
            ? this._setComponentSettingsCompat(payload)
            : setGlobalSettings(payload);
        await httpClient.request(req);
    }
    async getItem(key, options) {
        var _a;
        const { host } = this;
        const { namespace } = options;
        const payload = this._buildAppSettingsPayload({
            host: hostMap[host],
        }, options);
        const settings = await this._getSettingsCompat(payload);
        return (_a = settings === null || settings === void 0 ? void 0 : settings[namespace]) === null || _a === void 0 ? void 0 : _a[key];
    }
    async getAllItems(options) {
        const { host } = this;
        const { namespace } = options;
        const payload = this._buildAppSettingsPayload({
            host: hostMap[host],
        }, options);
        const settings = await this._getSettingsCompat(payload);
        return settings === null || settings === void 0 ? void 0 : settings[namespace];
    }
}
//# sourceMappingURL=app-settings.js.map